// Auth state utilities for NeuroHeal.
// JWT is stored server-side as an httpOnly cookie (set by /api/auth/login).
// We only cache the *non-sensitive* user profile in localStorage so the UI
// can render synchronously on initial load.

import api, { clearCsrfToken, clearAuthToken } from './api';
import logger from './logger';

const USER_STORAGE_KEY = 'neuroheal_user';

export const setUser = (user) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
};

export const isAuthenticated = () => {
  return !!getUser();
};

// Clears the httpOnly cookie on the backend, then wipes local user cache.
// Callers can optionally await this; navigation can happen immediately.
export const logout = async () => {
  try {
    await api.post('/auth/logout');
  } catch (err) {
    // Non-fatal: even if the network call fails we still wipe local state below.
    // Log so the failure is observable in devtools / error-reporting.
    logger.error('Logout request failed; clearing local state anyway.', err);
  }
  removeUser();
  clearCsrfToken();
  clearAuthToken();
  // Wipe the affiliate-status cache so the next login recomputes fresh.
  try { delete window.__neuroheal_affiliate_status__; } catch (_e) { /* ignore */ }
};
